export function isPreviewableAudio(mime, name) {
  const m = (mime || '').toLowerCase();
  if (m.startsWith('audio/')) return true;
  if (m.includes('mpeg') || m.includes('mp4')) {
    const n = (name || '').toLowerCase();
    if (/\.(mp3|m4a|aac|wav|flac|ogg|opus|weba?m|mp4)$/.test(n)) return true;
  }
  return /\.(mp3|m4a|aac|wav|flac|ogg|opus|weba?m|mp4|aiff?|caf)$/i.test(name || '');
}

export function formatAudioTime(seconds) {
  if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
  const total = Math.floor(seconds);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  if (h > 0) {
    return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }
  return `${m}:${String(s).padStart(2, '0')}`;
}

export function audioFileExtension(name, mimeType) {
  const fromName = (name || '').match(/\.([a-z0-9]+)$/i);
  if (fromName) return fromName[1].toLowerCase();
  const m = (mimeType || '').toLowerCase();
  if (m.includes('mpeg')) return 'mp3';
  if (m.includes('wav')) return 'wav';
  if (m.includes('ogg')) return 'ogg';
  if (m.includes('mp4') || m.includes('aac')) return 'm4a';
  return 'audio';
}
